export default __webpack_public_path__ + "locales/uk-UA/UploadPanel.json?hash=950227d7806272dfdbc802fa005dc325";